import user, { useUserStore } from './user';
import users from './users';

export default { user, users };

export { useUserStore };
